// src/slices/condicoesPagamento.js
import { createCrudThunks } from "./utils/thunk";
import { createCrudReducer } from "./utils/reducer";
import api from "./FormaPagamento/api";

const label = "Formas de pagamento";
const entidade = "formasPagamento";

export const { get, add, update, deletar } = createCrudThunks(entidade, api, label);
const FormaPagamentoReducer = createCrudReducer(entidade, { get, add, update, deletar });

export {
  get as getFormasPagamento,
  add as addNewFormaPagamento,
  update as updateFormaPagamento,
  deletar as deleteFormaPagamento,
};

export default FormaPagamentoReducer;